<template>
    <v-flex x16 class="sortable-handler">
    <v-card>
    <v-dialog v-model="showModal" hide-overlay transition="dialog-bottom-transition" class="sortable-handler">
        <v-card>
        <v-toolbar dark color="primary">
            <v-toolbar-side-icon></v-toolbar-side-icon>
            <v-toolbar-title>{{ itemEdit ? 'Edit' : 'Create' }} Device Groups</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-sm-and-down">
            <v-btn icon dark @click="closeModalCreate()">
                <v-icon>close</v-icon>
            </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-layout row wrap class="pa-4">
            <v-flex xs12 >
            </v-flex>
            <v-flex xs6 offset-xs3 class="pa-1">
            <v-card class="pa-2">
                <v-form ref="storeData" @submit.prevent="storeData()">
                  <v-select
                    :items="device_groups"
                    v-model="parent"
                    label="Select parent for group, Parent Default"
                    single-line
                    return-object
                    item-text="name"
                  ></v-select>
                  <v-text-field v-model="name" label="Name" v-validate="'required|max:75'" :error-messages="errors.collect('name')" data-vv-name="name"></v-text-field>
                  <v-text-field v-model="description" label="Description" :error-messages="errors.collect('description')" data-vv-name="description"></v-text-field>
                  <v-select
                    :items="managers"
                    v-model="managers_selected"
                    item-text="name"
                    label="Select Managers of the Group"
                    multiple
                    chips
                    persistent-hint
                    return-object
                  ></v-select>
                  <v-select
                    :items="devices"
                    v-model="devices_selected"
                    item-text="name"
                    label="Select Devices of the Group"
                    multiple
                    chips
                    persistent-hint
                    return-object
                  ></v-select>
                  <v-flex class="text-xs-right" shrink>
                    <v-btn color="primary" dark class="text-md-left text-sm-left" type="submit">
                        Save
                    </v-btn>
                  </v-flex>
                </v-form>
            </v-card>
            </v-flex>
        </v-layout>
        </v-card>
    </v-dialog>
    </v-card>
    </v-flex>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    itemEdit: {
      type: Object,
      required: false,
      default: null,
    }
  },
  data () {
    return {
      select: '',
      name: null,
      token: null,
      description: null,
      type: 'random',
      init_survey: 'random',
      excelName: '',
      excelFile: null,
      items: [],
      showModal: true,
      managers_selected: [],
      managers: [],
      devices_selected: [],
      devices: [],
      device_groups: [],
      parent: null,
    };
  },
  computed: {

  },
  mounted () {
    this.loadData();
  },
  methods: {
    closeModalCreate () {
      this.$emit('closeModal');
    },
    loadData () {
      let url = 'client/devicegroups/create';
      let _self = this;
      
      if (_self.itemEdit) {
        let url = 'client/devicegroups/' + _self.itemEdit.id + '/edit';
        _self.name = _self.itemEdit.name;
        _self.description = _self.itemEdit.description;
        window.axios.get(url).then((response) => {
          _self.managers = response.data.users;
          _self.devices = response.data.devices;
          _self.device_groups = response.data.device_groups;
          _self.parent = response.data.parent;
          _self.devices_selected = response.data.devices_selected;
          _self.managers_selected = response.data.managers_selected;
          _self.devices = _self.devices.concat(_self.devices_selected);

          _self.device_groups.forEach(function (value, key) {
            if (value.id === _self.itemEdit.id) {
              _self.device_groups.splice(key, 1);
            }
          });
        });
      } else {
        window.axios.get(url).then((response) => {
          _self.managers = response.data.users;
          _self.devices = response.data.devices;
          _self.device_groups = response.data.device_groups;
        });
      }
    },
    storeData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.itemEdit) {
            const payload = {
              name: this.name,
              devices_selected: this.devices_selected,
              managers_selected: this.managers_selected,
              parent: this.parent,
              description: this.description
            };
            let url = 'client/devicegroups/' + this.itemEdit.id;
            window.axios.put(url, payload).then(response => {
              this.$store.dispatch('setSnackbar', {
                show: true,
                color: 'success',
                text: 'Device update successfully.'
              });
              this.$emit('updateDeviceGroup', { 'value': response.data.data, 'index': this.itemEdit.index });
              this.closeModalCreate();
            }, response => {
              this.$store.dispatch('setSnackbar', {
                show: true,
                color: 'error',
                text: 'Server Error'
              });
            });
          } else {
            let url = 'client/devicegroups';
            const payload = {
              description: this.description,
              name: this.name,
              type: this.type,
              parent: this.parent,
              managers_selected: this.managers_selected,
              devices_selected: this.devices_selected
            };
            window.axios.post(url, payload).then((response) => {
              this.$store.commit('setLoading', false);
              this.$store.dispatch('setSnackbar', {
                show: true,
                color: 'success',
                text: 'Device Group saved successfully.'
              });
              this.$emit('addDeviceGroup', response.data.data);
              this.closeModalCreate();
            }).catch(error => {
              this.$store.dispatch('setSnackbar', {
                show: true,
                color: 'error',
                text: 'Server Error'
              });
            });
          }
        } else {
          this.$store.dispatch('setSnackbar', {
            show: true,
            color: 'info',
            text: 'Check the form, please.'
          });
        }
      });
    },
  }
};
</script>
<style>
  .d-flex{
    display: flex;
  }
  .text-center{
    text-align: center;
  }
  .color{
    display: block;
    width: 50px;
    height: 20px;
  }
  .sortable-handler {
    touch-action: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/client/devicegroups/ModalCreate.vue